import { KeyValue } from '@/main/models/common';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { Result } from '@/main/models/common/resultResponse';
import { ProcurementReportScheduleGridResponse } from '@/main/models/response';
import { AxiosResponse } from 'axios';

export abstract class IProcurementReportScheduleStatusAPI {
  abstract getProcurementReportScheduleStatus(): Promise<
    AxiosResponse<PaginationResponse<ProcurementReportScheduleGridResponse[]>>
  >;
}
